import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { SingletonSidebarActions } from "@/components/SingletonSidebarActions/SingletonSidebarActions";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { getCurrentContactEntity } from "@/models/contact";
import { Route } from "@/paths";
import { Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import { DealList } from "./DealList";

export const Sidebar = () => {
  const entity = getCurrentContactEntity();
  const { inactiveElementProps } = useIsPlanInactive();
  return (
    <LayoutWorkstationHeader
      header={
        <Breadcrumbs>
          <Text
            component={Link}
            mt={".13em"}
            fw={600}
            to={Route.Contacts}
            c="blue"
          >
            Contacts
          </Text>
          {/* <BreadcrumbSeperator />
          <BreadcrumbTitle>
            Contact
          </BreadcrumbTitle> */}
        </Breadcrumbs>
      }
    >
      <Stack
        h={"100%"}
        flex={1}
        p="xs"
        justify="space-between"
        {...inactiveElementProps}
      >
        <Stack gap={"xs"}>
          <DealList />
        </Stack>
        <SingletonSidebarActions
          entity={entity}
          confirmationPath={Route.Contacts}
        />
      </Stack>
    </LayoutWorkstationHeader>
  );
};
